import { call } from 'redux-saga/effects'
import { prepareForSave } from '../firebase/document'

export function* getParamsForBuyClickAdd(params) { // eslint-disable-line import/prefer-default-export
	const buyClick = yield call(prepareForSave, params.buyClick)
	return {
		...params,
		buyClick
	}
}

export function handleBuyClickRedirect({ buyClick }) {
	global.document.location.href = buyClick.url
	return { success: true, buyClick }
}



// WEBPACK FOOTER //
// ./src/redux/saga/buy/sagas.js